// @ vendor
const moment = require('moment');
// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');

function changeDay(date) {
    return {
        date,
        type: actionTypes.BROKER_MARKETS_DAY_CHANGED
    }
}

const eventsRequest = () => ({
    type: actionTypes.FETCH_BROKER_MARKET_CALENDAR_EVENTS_REQUEST
})

const eventsSuccess = (data) => ({
    type: actionTypes.FETCH_BROKER_MARKET_CALENDAR_EVENTS_SUCCESS,
    payload: {
        data: data.datos || []
    }
})

const eventsFailure = (error) => ({
    type: actionTypes.FETCH_BROKER_MARKET_CALENDAR_EVENTS_FAILURE,
    payload: {
        error
    }
})

const requestEvents = () => (dispatch, getState) => {
    const immBrokerMarketsCalendar = getState().brokerMarketsCalendar;
    const hasBeenFetched = immBrokerMarketsCalendar.get('hasBeenFetched');
    const isFetching = immBrokerMarketsCalendar.get('isFetching');
    const hasError = immBrokerMarketsCalendar.get('hasError');

    if (hasBeenFetched || isFetching || hasError){
        return Promise.resolve();
    }

    const today = moment().format(DATE_FORMAT_API);

    const requestData = {
        query: {
            fechaInicio: moment(today).startOf('isoWeek').format(DATE_FORMAT_API),
            fechaFin: moment(today).endOf('isoWeek').format(DATE_FORMAT_API)
        }
    };

    dispatch(eventsRequest());
    return APIGet({
        dispatch,
        endpoint: 'margekWFGAgenda',
        url: apiURLBuilder.getURL('margekWFGAgenda'),
        params: requestData
    })
    .then(response => dispatch(eventsSuccess(response)))
    .catch(response => dispatch(eventsFailure(response.error)));
}


module.exports = {
    changeDay,
    requestEvents
}
